import { useState, useEffect, useRef } from 'react';
import styles from './LoadingScreen.module.css';

function LoadingScreen({ progress, hiding }) {
  return (
    <div className={`${styles.screen} ${hiding ? styles.screenHidden : ''}`}>
      <div className={styles.glow1} />
      <div className={styles.glow2} />

      <h1 className={styles.brand}>
        Romi Peretz <span className={styles.brandAccent}>Academy</span>
      </h1>

      <div className={styles.divider}>
        <span className={styles.dividerLine} />
        <span className={styles.dividerDot}>✦</span>
        <span className={styles.dividerLine} />
      </div>

      <p className={styles.status}>העמוד בטעינה</p>

      <div className={styles.progressWrap}>
        <div className={styles.progressTrack}>
          <div
            className={styles.progressFill}
            style={{ width: `${progress}%` }}
          />
        </div>
        <span className={styles.percent}>{progress}%</span>
      </div>
    </div>
  );
}

/**
 * Hook that preloads the hero image and returns loading state + progress.
 */
export function usePageLoader(imageSrc) {
  const [loaded, setLoaded] = useState(false);
  const [hiding, setHiding] = useState(false);
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    // Simulate progress while image loads
    intervalRef.current = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 90) {
          clearInterval(intervalRef.current);
          return 90;
        }
        return prev + Math.floor(Math.random() * 8 + 3);
      });
    }, 200);

    // Actually preload the image
    const img = new Image();
    img.src = imageSrc;

    const onDone = () => {
      clearInterval(intervalRef.current);
      setProgress(100);
      setTimeout(() => setHiding(true), 300);
      setTimeout(() => setLoaded(true), 900);
    };

    if (img.complete) {
      onDone();
    } else {
      img.onload = onDone;
      img.onerror = onDone;
    }

    return () => clearInterval(intervalRef.current);
  }, [imageSrc]);

  return { loaded, hiding, progress };
}

export default LoadingScreen;
